import create from "zustand";
import { devtools, persist } from "zustand/middleware";

let store = (set) => ({
  isLoggedIn: false,
  user: null,
  permissions: null,
  login: (user) =>
    set((state) => ({
      isLoggedIn: true,
      user: user,
      permissions: user.permissions || null,
    })),
  logout: () => {
    // Clear token from localStorage when logging out
    localStorage.removeItem("tburudani_token");
    return set((state) => ({
      isLoggedIn: false,
      user: null,
      permissions: null,
    }));
  },
});

store = persist(store, { name: "tburudani_admin" });
store = devtools(store);

const useStore = create(store);

export default useStore;
